
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground, PropsTable } from 'docz';
import { DoczPage, Box, TextAccent, Link, Footer, SharePoll } from '../../../ui';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"footer"}}>{`Footer`}</MDXTag>
<MDXTag name="p" components={components}>{`Footer component is positioned fixed to the top of the page for desktop and tablet users, while it is positioned at the bottom for mobile users. It contains `}<MDXTag name="inlineCode" components={components} parentName="p">{`content`}</MDXTag>{` prop which enables it to pass whatever needed content on the left side.`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"properties"}}>{`Properties`}</MDXTag>
<PropsTable of={Footer} />
<MDXTag name="h2" components={components} props={{"id":"usage"}}>{`Usage`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"footer-for-createpoll-page-with-image-author-on-the-left-side"}}>{`Footer for CreatePoll page with image author on the left side`}</MDXTag>
<Playground __position={1} __code={'<DoczPage>\n  <Box\n    background={[\'#facc\']}\n    height={[\'300px\']}\n    display={[\'flex\']}\n    justifyContent={[\'flex-end\']}\n  >\n    <Footer\n      style={{ position: \'relative\' }}\n      content={\n        <Box display={[\'none\', \'block\', \'block\']}>\n          <TextAccent color=\"lightTransparent70\">\n            Photo by\n            <Link to=\"#\" kind=\"lightTransparent70\" target=\"_blank\">\n              Anthony DELANOIX\n            </Link>\n          </TextAccent>\n        </Box>\n      }\n    />\n  </Box>\n</DoczPage>'} __scope={{props: this ? this.props : props,DoczPage,Box,TextAccent,Link,Footer,SharePoll}}>
  <DoczPage>
    <Box background={['#facc']} height={['300px']} display={['flex']} justifyContent={['flex-end']}>
      <Footer style={{ position: 'relative' }} content={
        <Box display={['none', 'block', 'block']}>
        <TextAccent color="lightTransparent70">
          Photo by
          <Link to="#" kind="lightTransparent70" target="_blank">
            Anthony DELANOIX
          </Link>
        </TextAccent>
      </Box>}
      />
    </Box>
  </DoczPage>
</Playground>
<MDXTag name="h3" components={components} props={{"id":"footer-for-vote-page-with-share-functionality-on-the-left-side"}}>{`Footer for Vote page with share functionality on the left side`}</MDXTag>
<Playground __position={2} __code={'<DoczPage>\n  <Box\n    background={[\'#50c0ff\']}\n    height={[400]}\n    display={[\'flex\']}\n    alignItems={[\'flex-end\']}\n  >\n    <Footer\n      style={{ position: \'relative\' }}\n      content={\n        <SharePoll\n          pollCreatorEmoji=\"emoji_4\"\n          pollCreatorName=\"Mr. Ipsum\"\n          pollLink=\"jxasdag\"\n          pollQuestion=\"Okey folks, we need to make this decision, and we have to make it now! When should we go for lunch today?\"\n        />\n      }\n    />\n  </Box>\n</DoczPage>'} __scope={{props: this ? this.props : props,DoczPage,Box,TextAccent,Link,Footer,SharePoll}}>
  <DoczPage>
    <Box
      background={['#50c0ff']}
      height={[400]}
      display={['flex']}
      alignItems={['flex-end']}
    >
      <Footer
        style={{ position: 'relative' }}
        content={
          <SharePoll
            pollCreatorEmoji="emoji_4"
            pollCreatorName="Mr. Ipsum"
            pollLink="jxasdag"
            pollQuestion="Okey folks, we need to make this decision, and we have to make it now! When should we go for lunch today?"
          />
        }
      />
    </Box>
  </DoczPage>
</Playground>
<MDXTag name="h3" components={components} props={{"id":"footer-for-with-adbanner-on-the-right-side"}}>{`Footer for with AdBanner on the right side`}</MDXTag>
<Playground __position={3} __code={'<DoczPage>\n  <Box\n    background={[\'#acce\']}\n    height={[\'300px\']}\n    display={[\'flex\']}\n    justifyContent={[\'flex-end\']}\n  >\n    <Footer\n      showBanner\n      style={{ position: \'relative\' }}\n      content={\n        <Box display={[\'none\', \'block\', \'block\']}>\n          <TextAccent color=\"lightTransparent70\">\n            Photo by\n            <Link to=\"#\" kind=\"lightTransparent70\" target=\"_blank\">\n              Anthony DELANOIX\n            </Link>\n          </TextAccent>\n        </Box>\n      }\n    />\n  </Box>\n</DoczPage>'} __scope={{props: this ? this.props : props,DoczPage,Box,TextAccent,Link,Footer,SharePoll}}>
  <DoczPage>
    <Box background={['#acce']} height={['300px']} display={['flex']} justifyContent={['flex-end']}>
      <Footer showBanner style={{ position: 'relative' }} content={
        <Box display={['none', 'block', 'block']}>
        <TextAccent color="lightTransparent70">
          Photo by
          <Link to="#" kind="lightTransparent70" target="_blank">
            Anthony DELANOIX
          </Link>
        </TextAccent>
      </Box>}
      />
    </Box>
  </DoczPage>
</Playground>
           </MDXTag>
  }
}
  